import type { SearchClient } from "typesense";
import Typesense from "typesense";

export default defineNuxtPlugin<{ typesenseClient: SearchClient | undefined }>(
  () => {
    const apiKey = useRuntimeConfig().public.typesense.apiKey;
    const typesenseHost = useRuntimeConfig().public.typesense.host;

    if (!apiKey || !typesenseHost) {
      return {
        provide: {
          typesenseClient: undefined,
        },
      };
    }

    const typesenseClient = new Typesense.SearchClient({
      nodes: [
        {
          host: typesenseHost,
          port: 443,
          protocol: "https",
        },
      ],
      apiKey,
      cacheSearchResultsForSeconds: 15,
      useServerSideSearchCache: true,
    });

    return {
      provide: {
        typesenseClient,
      },
    };
  },
);
